import React, {useCallback} from 'react';
import {Checkbox, Stack, styled, Typography} from '@mui/material';
import RequiredAsterisk from './RequiredAsterisk';

const CheckboxLabel = styled(Typography, {shouldForwardProp: p=>!p.startsWith('$')})`
    color: ${p=>p.$disabled ? p.theme.palette.text.disabled
        : p.$checked ? p.theme.palette.text.primary
        : p.theme.palette.text.secondary};
    ${p=>p.$disabled ? '' : `
        cursor: pointer;
        &:hover {
            color: ${p.theme.palette.primary.dark};
        }
    `}
    transition: color 300ms ease-out;
`;

const SCCheckbox = React.forwardRef((props, ref)=>{
    let {
        label,
        value,
        disabled,
        required,
        onChange: _onChange,
        ...rest
    } = props;
    let onChange = useCallback(ev=>!disabled&&_onChange?.(ev.target.checked, ev),
        [disabled, _onChange]);
    let toggle = useCallback(()=>!disabled&&_onChange?.(!value),
        [disabled, _onChange, value]);
    return <Stack direction="row" alignItems="center" sx={{width: '100%'}}>
      <Checkbox ref={ref} checked={value} onChange={onChange} disabled={disabled} {...rest}/>
      {label&&<CheckboxLabel onClick={toggle} variant="body2"
        $disabled={disabled} $checked={value}>
        {label}
        {required&&<RequiredAsterisk/>}
      </CheckboxLabel>}
    </Stack>;
});

export default SCCheckbox;
